var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    attrs: { id: "pdf-editor-modal", "modal-class": "modal-fullscreen" },
    on: { show: _vm.init, hidden: _vm.reset },
    scopedSlots: _vm._u([
      {
        key: "header-custom",
        fn: function () {
          return [
            _c(
              "h4",
              { staticClass: "text-center modal-title" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("documents.combinePdf.reviewPDF")) +
                    "\n      "
                ),
                _c("transition", { attrs: { name: "slide-fade" } }, [
                  _vm.progress
                    ? _c(
                        "span",
                        {
                          staticClass: "small-rem ml-2",
                          class: _vm.progressClass,
                        },
                        [_vm._v("\n          " + _vm._s(_vm.progressMessage))]
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "slide-fade" } }, [
              _vm.rendering
                ? _c("p", { staticClass: "mb-0" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("documents.combinePdf.renderingOutOf", {
                            current: _vm.renderedPages.length,
                            total: _vm.maxPages,
                          })
                        ) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.loading ? _c("preview-loader") : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.loading,
                    expression: "!loading",
                  },
                ],
                staticClass: "row page-row",
              },
              [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c(
                      "div",
                      { staticClass: "sticky-top bg-white pb-2" },
                      [
                        _c("p", { staticClass: "bold mb-0" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("documents.combinePdf.organizeDocuments")
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("i18n", {
                          staticClass: "small",
                          attrs: {
                            tag: "p",
                            path: "documents.combinePdf.dragAndDropToReOrder",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "eyeIcon",
                              fn: function () {
                                return [_c("icon", { attrs: { name: "eye" } })]
                              },
                              proxy: true,
                            },
                            {
                              key: "expandIcon",
                              fn: function () {
                                return [
                                  _c("icon", {
                                    attrs: { name: "external-link-square" },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "draggable",
                      {
                        attrs: {
                          id: "page-container",
                          handle: "canvas",
                          element: "div",
                        },
                        model: {
                          value: _vm.pages,
                          callback: function ($$v) {
                            _vm.pages = $$v
                          },
                          expression: "pages",
                        },
                      },
                      _vm._l(_vm.pages, function (page) {
                        return _c(
                          "pdf-thumbnail",
                          _vm._b(
                            {
                              key: "page-" + page.pageNumber,
                              ref: "pages",
                              refInFor: true,
                              style: { opacity: page.rendered ? 1 : 0 },
                              attrs: { "current-page": _vm.currentPage },
                              on: {
                                preview: function ($event) {
                                  return _vm.handlePreview(page.pageNumber)
                                },
                                hide: function ($event) {
                                  return _vm.handleHide(page.pageNumber)
                                },
                              },
                            },
                            "pdf-thumbnail",
                            page,
                            false
                          )
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("transition", { attrs: { name: "slide-fade" } }, [
                  _vm.previewing
                    ? _c(
                        "div",
                        {
                          staticClass: "col-auto sticky-top",
                          staticStyle: { height: "max-content" },
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("p", { staticClass: "bold" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("global.words.preview")) +
                                    "\n                "
                                ),
                                _c("i", {
                                  staticClass:
                                    "ml-2 fa fa-times text-danger clickable",
                                  attrs: { "aria-hidden": "true" },
                                  on: { click: _vm.closePreview },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-auto" },
                              [
                                _c("icon", {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover.top.viewport",
                                      value: _vm.$t(
                                        "global.actions.rotateLeft"
                                      ),
                                      expression:
                                        "\n                  $t('global.actions.rotateLeft')\n                ",
                                      modifiers: {
                                        hover: true,
                                        top: true,
                                        viewport: true,
                                      },
                                    },
                                  ],
                                  staticClass: "clickable mr-1",
                                  attrs: { name: "undo" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handlePreview(
                                        _vm.currentPage,
                                        null,
                                        -90
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("icon", {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover.top.viewport",
                                      value: _vm.$t(
                                        "global.actions.rotateRight"
                                      ),
                                      expression:
                                        "\n                  $t('global.actions.rotateRight')\n                ",
                                      modifiers: {
                                        hover: true,
                                        top: true,
                                        viewport: true,
                                      },
                                    },
                                  ],
                                  staticClass: "clickable",
                                  attrs: { name: "repeat" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handlePreview(
                                        _vm.currentPage,
                                        null,
                                        90
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-auto" }, [
                              _c("p", { staticClass: "small d-inline mr-2" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.currentPage) +
                                    "/" +
                                    _vm._s(_vm.maxPages) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "fa fa-arrow-left mr-2 text-primary clickable",
                                class: { disabled: _vm.isFirstPage },
                                attrs: {
                                  "aria-hidden": "true",
                                  disabled: _vm.isFirstPage,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handlePreview(null, -1)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "fa fa-arrow-right text-primary clickable",
                                class: { disabled: _vm.isLastPage },
                                attrs: { "aria-hidden": "true" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handlePreview(null, 1)
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("pdf-preview", { ref: "preview" }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  loading: _vm.downloading,
                  "loading-status": _vm.savingStatus,
                  type: "button btn-sm",
                  "class-name": "btn btn-primary",
                  disabled: _vm.loading || _vm.rendering || _vm.downloading,
                },
                on: { click: _vm.handleSave },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("global.words.download")) +
                    "\n      "
                ),
                _c("em", { staticClass: "fa fa-file-archive-o pl-2" }),
              ]
            ),
            _vm._v(" "),
            _c(
              "simple-button",
              {
                attrs: {
                  type: "primary btn-sm",
                  loading: _vm.saving,
                  "loading-status": _vm.savingStatus,
                  disabled: _vm.loading || _vm.rendering || _vm.saving,
                },
                on: { click: _vm.handleSaveToDocuments },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("documents.saveToDocuments")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }